import React from "react";
import { validateChildComponent, validChildWrapperComponent } from "../../../shared/validation";
import { GroupedListItemBaseProps, ListItemBackgroundColor } from "./props";
import { validListItemComponents } from "./validation";

export const listItemDefaultBackgroundColor: ListItemBackgroundColor = "neutralHigh";

export const onRenderCell = (
    item: JSX.Element,
    backgroundColor?: ListItemBackgroundColor,
    disabled?: boolean,
    groupSpacerNestingDepth = 0,
    showDivider = true
) => React.cloneElement(item, {
    disabled,
    backgroundColor: item.props.backgroundColor || backgroundColor,
    groupSpacerNestingDepth,
    showDivider,
    ...item.props
});

const listParentValidationName = "List";

// We re-assign to the last ListItem in the array to turn the divider off
// tslint:disable-next-line: readonly-array
export const childrenAsElementArray = (children: React.ReactNode): JSX.Element[] => {
    const childArray = Array.isArray(children) ? children : children ? [children] : [];
    return childArray.map(child => validateChildComponent(child, validListItemComponents, listParentValidationName));
};

export function listItemComponent<T extends {}>(component: React.FC<Omit<T, keyof GroupedListItemBaseProps>>): React.FC<T> {
    return validChildWrapperComponent(component, validListItemComponents, listParentValidationName);
}
